import apiUniqueKeySupervisor from '@/services/API/UniqueKeySupervisor'

const setUniqueKey = function({ commit }, uniqueKeyPayLoad) {
    commit('SET_UNIQUE_KEY', uniqueKeyPayLoad)
}

const setPermission = function({ commit }, permissionPayLoad) {
    commit('SET_PERMISSION', permissionPayLoad)
}

const authorize = async function({ state }) {
    let response = await apiUniqueKeySupervisor.authPermission(state.uniqueKey, state.permission)
    return response
}

const resetState = function({ commit }) {
    commit('RESET')
}

// const checkUniqueKey = function({ commit }, uniqueKeyPayLoad) {
//     //commit('SET_UNIQUE_KEY', uniqueKeyPayLoad)
// }

export default {
    setUniqueKey,
    setPermission,
    authorize,
    resetState
    //checkUniqueKey,
}
